
export enum DeltaVarianceTypeCd {
	BAD = 'Bad',
	GOOD = 'Good',
	NEUTRAL = 'Neutral'}

